import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class DeviceRegisteredGuard {
  // To be used until we create functionality.
  isStationRegistered = true;

  constructor(
    private router: Router,
  ) { }

  canLoad(): Observable<boolean> {
    return this.isDeviceRegistered()
      .pipe(map((isRegistered: boolean) => {
        if (!isRegistered) {
          this.router.navigate(['/register-device']);
        }
        return isRegistered;
      }));
  }

  private isDeviceRegistered(): Observable<boolean> {
    // Keeping this stub for when we show that the station is not registered
    return of(this.isStationRegistered);
  }
}
